module.exports = __webpack_public_path__ + "media/images/verte-3e8c24f68ac2fa7f7e490d0d127c75e9.png";